export const toCoordinate = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = typeof value === "number" ? value : Number(value);
  return Number.isFinite(number) ? number : null;
};

export const isValidLatLng = (latitude, longitude) => {
  const lat = toCoordinate(latitude);
  const lng = toCoordinate(longitude);
  if (lat === null || lng === null) return false;
  return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
};

export const collectMarkerLatLngs = (markers) => {
  if (!Array.isArray(markers)) return [];
  const points = [];
  const seen = new Set();

  markers.forEach((marker) => {
    const output = marker?.addressOutputs?.[0];
    const lat = toCoordinate(output?.latitude);
    const lng = toCoordinate(output?.longitude);
    if (!isValidLatLng(lat, lng)) return;
    const key = `${lat},${lng}`;
    if (seen.has(key)) return;
    seen.add(key);
    points.push([lat, lng]);
  });

  return points;
};

export const normalizeBounds = (bounds) => {
  if (!bounds) return null;
  const south = toCoordinate(bounds.south);
  const north = toCoordinate(bounds.north);
  const west = toCoordinate(bounds.west);
  const east = toCoordinate(bounds.east);
  if ([south, north, west, east].some((value) => value === null)) return null;
  if (south > north) return null;
  return { south, north, west, east };
};

export const sameMapBounds = (left, right) => {
  const a = normalizeBounds(left);
  const b = normalizeBounds(right);
  if (!a || !b) return a === b;
  return (
    Math.abs(a.south - b.south) < 1e-6 &&
    Math.abs(a.north - b.north) < 1e-6 &&
    Math.abs(a.west - b.west) < 1e-6 &&
    Math.abs(a.east - b.east) < 1e-6
  );
};

export const isLatLngInBounds = (latitude, longitude, bounds) => {
  const box = normalizeBounds(bounds);
  const lat = toCoordinate(latitude);
  const lng = toCoordinate(longitude);
  if (!box || !isValidLatLng(lat, lng)) return false;
  if (lat < box.south || lat > box.north) return false;
  if (box.west <= box.east) {
    return lng >= box.west && lng <= box.east;
  }
  return lng >= box.west || lng <= box.east;
};

export const organizationPositions = (organization) => {
  const outputs = organization?.addressOutputs;
  if (Array.isArray(outputs) && outputs.length > 0) {
    return outputs
      .map((output) => [
        toCoordinate(output?.latitude),
        toCoordinate(output?.longitude),
      ])
      .filter(([lat, lng]) => isValidLatLng(lat, lng));
  }
  const lat = toCoordinate(organization?.latitude);
  const lng = toCoordinate(organization?.longitude);
  if (!isValidLatLng(lat, lng)) return [];
  return [[lat, lng]];
};

export const isOrganizationInBounds = (organization, bounds) =>
  organizationPositions(organization).some(([lat, lng]) =>
    isLatLngInBounds(lat, lng, bounds),
  );

export const filterOrganizationsByBounds = (organizations, bounds) => {
  if (!Array.isArray(organizations)) return [];
  if (!normalizeBounds(bounds)) return organizations;
  return organizations.filter((organization) =>
    isOrganizationInBounds(organization, bounds),
  );
};
